'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '../../common/Button';
import { verdictFor } from './circleScoring';
type Props = {
  /** null until a lap has been scored. */
  accuracy: number | null;
  /** True when the sweep stopped short of a full turn. */
  incomplete: boolean;
  best: string | null;
  onRetry: () => void;
};

/**
 * The panel under the canvas. Its height is reserved even when empty so
 * finishing a circle doesn't shove the drawing area up the page.
 */
const CircleResult = t0 => {
  const $ = _c(15);
  const {
    accuracy,
    incomplete,
    best,
    onRetry
  } = t0;
  let t1;
  if ($[0] !== accuracy) {
    t1 = accuracy !== null && <><p className="text-5xl font-bold tabular-nums text-textPrimary">{accuracy.toFixed(1)}%</p><p className="mt-1 text-sm text-textSecondary">{verdictFor(accuracy)}</p></>;
    $[0] = accuracy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== incomplete) {
    t2 = incomplete && <p className="text-textPrimary">You have to make it the whole way around.</p>;
    $[2] = incomplete;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== accuracy || $[5] !== incomplete || $[6] !== onRetry) {
    t3 = (accuracy !== null || incomplete) && <Button text="Try again" variant="SECONDARY" classNames="mt-4" onClick={onRetry} />;
    $[4] = accuracy;
    $[5] = incomplete;
    $[6] = onRetry;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== best) {
    t4 = best !== null && <p className="mt-3 text-sm text-textGray">Personal best: {Number(best).toFixed(1)}%</p>;
    $[8] = best;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="mt-6 flex min-h-[104px] w-full max-w-[440px] flex-col items-center">{t1}{t2}{t3}{t4}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default CircleResult;